import React, { useContext } from 'react';
import LocaleContext from '../../../constants/localization';

const MAX_COLUMNS = 4;

const UserList = ({
  users,
  handleToggle,
  setSelectView,
  setSelectedGroup,
  handleDelete,
}) => {
  const LS = useContext(LocaleContext);

  return (
    <table className="group-table">
      {Object.keys(users).length > 0 ? (
        <>
          <thead>
            <tr>
              <th style={{ width: '90px' }}>{LS.manageUsers.tableActive}</th>
              <th
                style={{
                  textAlign: 'left',
                }}
              >
                {LS.manageUsers.tableUsername}
              </th>
              <th
                style={{
                  textAlign: 'left',
                }}
              >
                {LS.manageUsers.name}
              </th>
              <th style={{ width: '20%' }}>
                {LS.manageUsers.tableQuickActions}
              </th>
            </tr>
          </thead>
          <tbody>
            {users.map(([key, value]) => {
              return (
                <tr key={key} className="user-table__row">
                  <td
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={users.find((u) => u[0] === key)[1].active}
                        onChange={() => handleToggle(key)}
                      />
                      <span className="slider" />
                    </label>
                  </td>
                  <td
                    onClick={() => {
                      setSelectView(false);
                      setSelectedGroup(key);
                    }}
                  >
                    {value.username}
                  </td>
                  <td
                    onClick={() => {
                      setSelectView(false);
                      setSelectedGroup(key);
                    }}
                  >
                    {value.name}
                  </td>
                  <td
                    style={{
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <a
                      className="manage-users--button__edit"
                      onClick={() => {
                        setSelectView(false);
                        setSelectedGroup(key);
                      }}
                    >
                      {LS.manageUsers.edit} <i className="fa fa-edit" />
                    </a>
                    {!users.find((u) => u[0] === key)[1].active && (
                      <a
                        className="manage-users--button__delete"
                        onClick={() => handleDelete(key)}
                      >
                        {LS.manageUsers.delete} <i className="fa fa-trash" />
                      </a>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </>
      ) : (
        <tbody>
          <tr>
            <td colSpan={MAX_COLUMNS}>{LS.manageUsers.tableNoSearchResults}</td>
          </tr>
        </tbody>
      )}
    </table>
  );
};

export default UserList;
